import React from 'react'
import Chart from 'react-apexcharts'
import DashboardCard from '../../containers/Dashboard/components/Dashboard/component/Card'
import { useGlobal } from '../../shared'
import { urls } from '../../shared/config'

const ApexChart = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const { data: revenueData } = useGlobal({
    userUrl: `${urls.REVENUE}${customRole == 'Admin' ? userSchoolId : ''}`,
  })
  const totalReceived = revenueData?.totalReceived || 0
  const monthlyReceived = revenueData?.monthlyReceived || []

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  const seriesData = Array(12).fill(0)

  // if (revenueData && revenueData.length > 0) {
  //   const dataPoint = revenueData[0]
  //   const monthIndex = dataPoint.month - 1
  //   seriesData[monthIndex] = dataPoint.totalRevenue
  // }

  monthlyReceived.forEach((dataPoint) => {
    const monthIndex = dataPoint.month - 1
    seriesData[monthIndex] = dataPoint.totalRevenue
  })

  const chartData = {
    series: [
      {
        name: 'series1',
        data: seriesData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true, // Ensure the toolbar is visible
          offsetX: -15, // Adjust horizontal position
          offsetY: -30, // Adjust vertical position
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: months,
      },
      yaxis: {
        tickAmount: 5,
        labels: {
          formatter: function (value) {
            if (value >= 1000) {
              return (value / 1000)?.toFixed(1) + 'K'
            }
            return value.toString()
          },
        },
      },
      tooltip: {
        x: {
          format: 'MMM',
        },
      },
    },
  }

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <DashboardCard title={'Recieved'} content={`₹${totalReceived}`} expense />
        {/* <SelectPopUp
          title={'Monthly'}
          selectedStatus={selectedMonth}
          setSelectedStatus={setSelectedMonth}
          selectOptions={monthOptions}
        /> */}
      </div>
      <div id="chart">
        <Chart options={chartData.options} series={chartData.series} type="area" />
      </div>
      <div id="html-dist"></div>
    </div>
  )
}

export default ApexChart
